import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "react-bootstrap";
import { FiLogIn } from "react-icons/fi";

const LoginButton = () => {
  const { loginWithRedirect } = useAuth0();

  return <Button  variant="" className="login-btn" onClick={() => loginWithRedirect()}>Sign-in <FiLogIn/></Button>;
};

export default LoginButton;